/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li2_TextInputs */

const tr_onbilgi_s11_li2_text = /** @type {(inputs: Onbilgi_S11_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Chrome 110+, Mozilla Firefox 115+, Apple Safari 16+, Microsoft Edge 110+. JavaScript ve çerez desteğinin aktif olması gerekir.`)
};

const en_onbilgi_s11_li2_text = /** @type {(inputs: Onbilgi_S11_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Chrome 110+, Mozilla Firefox 115+, Apple Safari 16+, Microsoft Edge 110+. JavaScript and cookie support must be enabled.`)
};

const de_onbilgi_s11_li2_text = /** @type {(inputs: Onbilgi_S11_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Chrome 110+, Mozilla Firefox 115+, Apple Safari 16+, Microsoft Edge 110+. JavaScript und Cookie-Unterstützung müssen aktiv sein.`)
};

const ru_onbilgi_s11_li2_text = /** @type {(inputs: Onbilgi_S11_Li2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Chrome 110+, Mozilla Firefox 115+, Apple Safari 16+, Microsoft Edge 110+. Поддержка JavaScript и файлов cookie должна быть включена.`)
};

/**
* | output |
* | --- |
* | "Google Chrome 110+, Mozilla Firefox 115+, Apple Safari 16+, Microsoft Edge 110+. JavaScript and cookie support must be enabled." |
*
* @param {Onbilgi_S11_Li2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li2_text = /** @type {((inputs?: Onbilgi_S11_Li2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li2_text(inputs)
	if (locale === "de") return de_onbilgi_s11_li2_text(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li2_text(inputs)
	return tr_onbilgi_s11_li2_text(inputs)
});